module.exports = __webpack_public_path__ + "img/cate_product5.895e00c2.png";